import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {SongEntity, SongState} from '@spout/global-any/models';

export const songAdapter: EntityAdapter<SongEntity> =
  createEntityAdapter<SongEntity>();

export const initialSongState: SongState = songAdapter.getInitialState({
  // additional entity state properties
});
